import { runDemo } from "../shared/demoRunner";
import { createActionsScene } from "./scene";

runDemo({ createScene: createActionsScene });
